import React from "react";
import { Form } from "./components";

export function mapOptionsFromProps({ name, alwaysValidate, values, rules, onSubmit, onChange }) {
    // collect the options we can use from the props
    const options = {
        name,
        alwaysValidate,
        values,
        rules,
        onSubmit,
        onChange
    };
    // filter out any undefined values so they don't override statically defined options
    return Object.entries(options)
        .filter(([, value]) => typeof value !== "undefined")
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
}

export function withForm(formOptions, mapOptionsFromPropsFunc = () => ({})) {
    return (Component) => {
        return (props) => (
            <Form {...formOptions} {...mapOptionsFromPropsFunc(props)}>
                <Component {...props} />
            </Form>
        );
    };
}
